/* VIVID — reviews auto-scroll. Transform-based for smoothness.
   - GPU translate3d → sub-pixel smooth even at slow speeds (no scrollLeft stutter).
   - Auto-scroll pauses on hover / focus; drag (mouse + touch) with momentum.
   - Seamless loop via cloned cards.
   - Respects prefers-reduced-motion (leaves the native scrollable carousel as-is). */
(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function init(track) {
    var speed = parseFloat(track.getAttribute('data-reviews-speed')) || 40; // px per second
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    // Build an inner track we can transform, and move the cards into it.
    var inner = document.createElement('div');
    inner.style.cssText = 'display:flex;flex:0 0 auto;flex-wrap:nowrap;gap:1.6rem;width:max-content;will-change:transform;';
    while (track.firstChild) inner.appendChild(track.firstChild);
    track.appendChild(inner);
    track.style.overflow = 'hidden';
    track.style.display = 'block';
    track.style.touchAction = 'pan-y';

    // Clone the original set for a seamless loop.
    cards.forEach(function (c) {
      var clone = c.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      inner.appendChild(clone);
    });

    var period = inner.children[cards.length].offsetLeft; // width of one original set
    function recalc() { period = inner.children[cards.length].offsetLeft; }
    window.addEventListener('resize', recalc, { passive: true });
    window.addEventListener('load', recalc);

    var pos = 0;
    var v = speed;            // current velocity (px/s)
    var mode = 'auto';        // 'auto' | 'inertia'
    var paused = false;       // hover / focus
    var hovering = false;
    var dragging = false;
    var startX = 0, startPos = 0, lastX = 0, lastT = 0;
    var lastTs = null;

    function apply() {
      if (period > 0) pos = ((pos % period) + period) % period;
      inner.style.transform = 'translate3d(' + (-pos) + 'px,0,0)';
    }

    track.addEventListener('mouseenter', function () { hovering = true; paused = true; });
    track.addEventListener('mouseleave', function () { hovering = false; if (!dragging) paused = false; });
    track.addEventListener('focusin', function () { paused = true; });
    track.addEventListener('focusout', function () { if (!hovering && !dragging) paused = false; });

    track.addEventListener('pointerdown', function (e) {
      dragging = true; paused = true; mode = 'auto'; v = speed;
      startX = e.clientX; startPos = pos; lastX = e.clientX; lastT = e.timeStamp;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      pos = startPos - (e.clientX - startX);
      var dt = (e.timeStamp - lastT) / 1000;
      if (dt > 0) v = -(e.clientX - lastX) / dt; // velocity in scroll direction
      lastX = e.clientX; lastT = e.timeStamp;
      apply();
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      v = Math.max(-2600, Math.min(2600, v)); // clamp fling speed
      mode = 'inertia';
      if (!hovering) paused = false;
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    function frame(ts) {
      if (lastTs == null) lastTs = ts;
      var dt = (ts - lastTs) / 1000; lastTs = ts;
      if (dt > 0.05) dt = 0.05; // clamp big gaps (tab was inactive)
      if (!dragging) {
        if (mode === 'inertia') {
          pos += v * dt;
          v += (speed - v) * Math.min(1, dt * 2.2); // ease velocity back to auto speed
          if (Math.abs(v - speed) < 3) { v = speed; mode = 'auto'; }
          apply();
        } else if (!paused) {
          pos += speed * dt;
          apply();
        }
      }
      requestAnimationFrame(frame);
    }
    apply();
    requestAnimationFrame(frame);
  }

  function boot() {
    document.querySelectorAll('[data-reviews-autoscroll]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
